
import {of as observableOf,  Observable } from 'rxjs';

import {mergeMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpRepository } from './http.repository';
import { GlobalConfig } from '../configs/GlobalConfig';
import { Language } from '../interfaces/rest/Language';
import { HttpClient } from "@angular/common/http";

@Injectable()
export class LanguageRepository {

    constructor(private http: HttpClient,
                private httpRepository: HttpRepository) {
    }

    /**
     * Get languages.
     * @returns {Observable<Array<Language>>}
     */
    getLanguages(): Observable<Array<Language>> {
        return this.httpRepository.get(GlobalConfig.endpoints.languages);
    }

    /**
     * Get language by language ID.
     * @param {number} languageId
     * @returns {Observable<Language>}
     */
    getLanguageById(languageId: number): Observable<Language> {
        return this.getLanguages().pipe(
            mergeMap((data: Array<Language>) => {
                let result: Language|undefined;
                if (data) {
                    result = data.find((languageData: Language) => {
                        return languageData.languageId === languageId;
                    })!;
                }

                return observableOf(result!);
            }));
    }

    /**
     * Create a new language.
     * @param {Language} payload
     * @returns {Observable<any>}
     */
    addLanguage(payload: Language) {
        return this.httpRepository.post(GlobalConfig.endpoints.languages, payload);
    }

    /**
     * Update existing language.
     * @param {Language} payload
     * @param languageId
     * @returns {Observable<any>}
     */
    updateLanguage(payload: Language, languageId: any) {
        return this.httpRepository.put(`${GlobalConfig.endpoints.languages}/${languageId}`, payload);
    }

    /**
     * Delete an existing language by ID.
     * @param languageId
     * @returns {Observable<any>}
     */
    deleteLanguage(languageId: any) {
        return this.httpRepository.delete(`${GlobalConfig.endpoints.languages}/${languageId}`);
    }
} /* istanbul ignore next */
